// extracted by mini-css-extract-plugin
export var author = "index-module--author--Ni86q";
export var category = "index-module--category--r7ijl";
export var container = "index-module--container--5k8y8";
export var excerpt = "index-module--excerpt--eX1Yy";
export var thumbnail = "index-module--thumbnail--mo0ch";
export var title = "index-module--title--4Nvw4";